<template>
  <el-dialog
    :title="form.roomUid ? $t('upgrade_page_views_administrator_management_voice_room_form_1995') : $t('upgrade_page_views_administrator_management_voice_room_form_1996')"
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item :label="$t('upgrade_page_views_administrator_management_voice_room_form_1997')">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <div class="upload-box">
        <span class="upload-title">{{$t('upgrade_page_views_administrator_management_voice_room_form_1998')}}</span>
        <el-upload
          class="avatar-uploader"
          action="https://api.dev.nicee.app/basic/image/upload"
          :show-file-list="false"
          :http-request="uploadCoverImg"
          :before-upload="beforeAvatarUpload"
          accept="image/png,image/jpg,image/jpeg,image/webp"
          v-loading="uploadCoverImgLoading"
        >
          <img v-if="form.coverImgUrl" :src="form.coverImgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="upload-box">
        <span class="upload-title">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1986')}}</span>
        <el-upload
          class="avatar-uploader"
          action="https://api.dev.nicee.app/basic/image/upload"
          :show-file-list="false"
          :http-request="uploadBackImg"
          :before-upload="beforeAvatarUpload"
          accept="image/png,image/jpg,image/jpeg,image/webp"
          v-loading="uploadBackImgLoading"
        >
          <img v-if="form.backImgUrl" :src="form.backImgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <el-form-item :label="$t('upgrade_page_views_administrator_management_voice_room_detail_1990')">
        <el-radio v-model="form.recommend" :label="1">{{$t('upgrade_page_views_administrator_management_voice_room_form_1999')}}</el-radio>
        <el-radio v-model="form.recommend" :label="0">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1991')}}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_administrator_management_voice_room_detail_1992')">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6 }"
          placeholder=""
          v-model="form.desc"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('upgrade_page_layout_header_42')}}</el-button>
      <el-button
        type="primary"
        :disabled="submitDisabled"
        :loading="submitLoading"
        @click="submit()"
        >{{$t('upgrade_page_layout_header_41')}}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import i18n from '@/locales/index'
import { uploadImageToS3 } from '@/api';
export default {
  name: 'editVoiceRoom',
  props: {
    voiceRoomDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        backImgUrl: '',
        coverImgUrl: '',
        desc: '',
        recommend: '1'
      },
      submitLoading: false,
      uploadBackImgLoading: false,
      uploadCoverImgLoading: false
    };
  },
  watch: {},
  computed: {
    submitDisabled() {
      return !(this.form.name && this.form.backImgUrl && this.form.coverImgUrl);
    }
  },
  methods: {
    submit() {
      if (this.submitLoading) return;
      this.submitLoading = true;
      if (this.form.roomUid) {
        this.editVoiceRoom();
      } else {
        this.createVoiceRoom();
      }
    },
    editVoiceRoom() {
      this.$http
        .post('/voiceRoom/update', {
          ...this.form
        })
        .then(() => {
          this.submitLoading = false;
          this.$message.success(i18n.t('upgrade_page_views_user_set_account_799'));
          this.$emit('update-success');
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message.error(i18n.t('upgrade_page_views_administrator_management_voice_room_form_2000'));
          this.submitLoading = false;
        });
    },
    createVoiceRoom() {
      this.$http
        .post('/voiceRoom/createOrUpdate', {
          ...this.form,
          gameType: 0,
          seats: 1,
          roomTheme: 1,
          roomType: 1
        })
        .then(() => {
          this.submitLoading = false;
          this.$message.success(i18n.t('upgrade_page_views_administrator_management_voice_room_form_2001'));
          this.$emit('create-success');
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message.error(i18n.t('upgrade_page_views_administrator_management_voice_room_form_2002'));
          this.submitLoading = false;
        });
    },
    open() {
      this.form.name = this.voiceRoomDetail.name;
      this.form.backImgUrl = this.voiceRoomDetail.backImgUrl;
      this.form.coverImgUrl = this.voiceRoomDetail.coverImgUrl;
      this.form.desc = this.voiceRoomDetail.desc;
      this.form.recommend = this.voiceRoomDetail.recommend;
      this.form.roomUid = this.voiceRoomDetail.roomUid;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        'image/jpg' ||
        'image/png' ||
        'image/webp';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error(i18n.t('upgrade_page_views_administrator_management_voice_room_form_2003'));
      }
      if (!isLt2M) {
        this.$message.error(i18n.t('upgrade_page_views_administrator_management_voice_room_form_2004'));
      }
      return isJPG && isLt2M;
    },
    //上傳背景圖片
    uploadBackImg({ file }) {
      this.uploadBackImgLoading = true;
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd)
        .then(({ data }) => {
          this.form.backImgUrl = data;
          this.uploadBackImgLoading = false;
        })
        .catch(() => {
          this.uploadBackImgLoading = false;
        });
    },
    //上傳封面圖片
    uploadCoverImg({ file }) {
      this.uploadCoverImgLoading = true;
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd)
        .then(({ data }) => {
          this.form.coverImgUrl = data;
          this.uploadCoverImgLoading = false;
        })
        .catch(() => {
          this.uploadCoverImgLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-form-item__label {
  text-align: left;
}
.upload-box {
  display: flex;
  margin-bottom: 22px;
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px solid #ebebeb;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      font-size: 30px;
      color: #ebebeb;
    }
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .upload-title {
    width: 80px;
    padding-right: 12px;
    text-align: left;
    line-height: 40px;
  }
}
</style>
